import './App.css';

function JoinUs() {
  return (
      <section className="contentSection">
        <div className="sectionHeading">
          <span className="sectionHeading__number">02</span>
          <div>
            <p className="eyebrow">Lobo Powerlifting</p>
            <h2>Join Us</h2>
          </div>
        </div>

        <div className="contentGrid">
          <article className="infoCard">
            <p className="infoCard__label">01</p>
            <h3>Requirements</h3>
            <ul className="featureList">
              <li>Be enrolled in a degree program at UNM as either an undergraduate or a graduate student.</li>
              <li>Be in good academic standing and enrolled full time.</li>
              <li>Have a general interest in the sport of powerlifting and a desire to compete.</li>
            </ul>
          </article>

          <article className="infoCard infoCard--accent">
            <p className="infoCard__label">02</p>
            <h3>Steps to Join Us</h3>
            <ol className="stepList">
              <li><a href="https://unm.presence.io/organization/lobo-powerlifting">Click here</a> to join our club officially on UNM Presence.</li>
              <li>Email <a href="mailto:lobopowerlifting@clubs.unm.edu">lobopowerlifting@clubs.unm.edu</a> asking us for further steps to join the team.</li>
            </ol>
          </article>
        </div>
      </section>
  );
}

export default JoinUs;
